import { useCallback } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

export type Translate = (key: string) => string;

export const useTranslation = (): Translate => {
  const { language } = useLanguage();

  return useCallback(
    (key: string) => getTranslation(language, key),
    [language]
  );
};
